import { render } from "./BiotronUpdatePage.vue?vue&type=template&id=63f3e37d"
import script from "./BiotronUpdatePage.vue?vue&type=script&lang=js"
export * from "./BiotronUpdatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__